import { doc, getFirestore, updateDoc } from 'firebase/firestore';

// 学校が登録した内定(学校管理画面の「内定先を登録」)。
// 学生のデータ users/{uid}.schoolOffers.{schoolId} に、学校ごとの配列で保存する
// (学生アプリ・サロン側では使わない。書けるのはその学生の学校だけ: firestore.rules の isSchoolOfferUpdate)。
export type SchoolOffer = {
  id: string;
  recruitId: string;   // memorii の求人から選んだとき(手入力のときは '')
  companyId: string;   // 同上
  salonName: string;
  offeredAt: string;   // 'YYYY-MM-DD'(任意)
  memo: string;
  createdAt: number;
};

export const schoolOffersOf = (user: any, schoolId: string): SchoolOffer[] => {
  const list = user?.schoolOffers?.[schoolId];
  return Array.isArray(list) ? list : [];
};

// 内定承諾は、学生が登録しても学校が登録しても1人1件として数える
export const hasOffer = (user: any, schoolId: string): boolean =>
  (user?.analytics?.applyStatusCount?.内定承諾 ?? 0) > 0 || schoolOffersOf(user, schoolId).length > 0;

export const offerCount = (user: any, schoolId: string): number => (hasOffer(user, schoolId) ? 1 : 0);

export async function saveSchoolOffers(uid: string, schoolId: string, offers: SchoolOffer[]): Promise<void> {
  await updateDoc(doc(getFirestore(), 'users', uid), {
    [`schoolOffers.${schoolId}`]: offers,
    schoolOffersUpdatedBy: schoolId,
  });
}
